import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { chatApi } from './chatApi';

export type InboxFilterOption = { id: string; name: string; color?: string; avatarUrl?: string };

export const INBOX_DEFAULT_STATUS = 'OPEN';

// Inbox list filter, kept here so it stays applied until the user changes it
// (survives opening conversations, collapsing the nav, switching tabs and leaving the inbox).
// It applies to every tab; tabs that own a field (Mine/Unassigned: users, My Teams: teams) ignore it.
export interface InboxFilter {
  // ALL / OPEN / CLOSED
  status: string;
  users: InboxFilterOption[];
  teams: InboxFilterOption[];
  labels: InboxFilterOption[];
}

const initialInboxFilter: InboxFilter = {
  status: INBOX_DEFAULT_STATUS,
  users: [],
  teams: [],
  labels: [],
};

// Define the type for state
interface AccountState {
  conversations: any;
  messageList: any;
  isPrivateNoteR: boolean;
  inboxFilter: InboxFilter;
}

const initialState: AccountState = {
  conversations: [],
  messageList: [],
  isPrivateNoteR: false,
  inboxFilter: initialInboxFilter,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setConversations: (state, action: PayloadAction<any>) => {
      state.conversations = action.payload;
    },
    setMessageList: (state, action: PayloadAction<any>) => {
      state.conversations = action.payload;
    },
    setChatStateInitial: (state) => {
      state.conversations = [];
      state.messageList = [];
      state.inboxFilter = initialInboxFilter;
    },
    setIsPrivateNoteR: (state, action: PayloadAction<boolean>) => {
      state.isPrivateNoteR = action.payload;
    },
    setInboxFilter: (state, action: PayloadAction<InboxFilter>) => {
      state.inboxFilter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(chatApi.endpoints.filterConversation.matchFulfilled, (state, action) => {
        state.conversations = action?.payload?.list ?? null;
      })
      .addMatcher(chatApi.endpoints.createConversation.matchFulfilled, (state, action) => {
        state.conversations = state.conversations
          ? [...state.conversations, action.payload?.list]
          : [action.payload?.list];
      })
      .addMatcher(chatApi.endpoints.getMessageList.matchFulfilled, (state, action) => {
        state.messageList = state.messageList
          ? [...action.payload.list, ...state.messageList] // Prepend messages
          : [...action.payload.list]; // Ensure list initializes correctly

        // state.totalPages = action.payload.totalPages; // Store total pages for future requests
      })

      .addMatcher(chatApi.endpoints.sendMessage.matchFulfilled, (state, action) => {
        state.messageList = state.messageList
          ? [...state.messageList, action.payload]
          : [action.payload];
      });

    // .addMatcher(accountAPi.endpoints.deleteAccount.matchFulfilled, (state, action) => {
    //   state.accountList =
    //     state.accountList?.filter((account) => account.id !== action.payload.id) || [];
    // });
  },
});

export const {
  setConversations,
  setMessageList,
  setChatStateInitial,
  setIsPrivateNoteR,
  setInboxFilter,
} = chatSlice.actions;
export default chatSlice.reducer;
